import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {   Headers  } from '@angular/http';
import { Badge } from '../entity/badge';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { ResponseContentType, Http } from '@angular/http';
import { Visitor } from '@angular/compiler/src/i18n/i18n_ast';
import { Visiteur } from '../entity/visiteur';

@Injectable({
  providedIn: 'root'
})
export class BadgeServiceService {
  private baseUrl = environment.restApi;
  private badgeUrl = `${this.baseUrl}badge`;
constructor(private http: HttpClient   ) { }


getAll(): Observable<any> {
  return this.http
     .get<Badge[]>(this.badgeUrl)
     .pipe(
         tap(_ => this.notify('fetched abstractEntities', 'GET')),
         catchError(this.handleError('getBadges', 'GET'))
     );
}
print(badge: Badge,typeClient:string ): any {
  //console.log('print badge'+JSON.stringify(badge));
  
  return this.http.get(this.badgeUrl + '/printPdf/' + badge.id+'/'+typeClient, { responseType: "blob"})  ;
} 
printVisitor(badge: Visiteur ): any {
  //console.log('print badge'+JSON.stringify(badge));
  
  return this.http.get(this.badgeUrl + '/printVisitor/' + badge.id , { responseType: "blob"})  ;
}

private getHeaders1() {
  const headers = new Headers();
  headers.append('Accept', 'application/pdf');
  headers.append('Content-Type', 'application/pdf');
  return headers;
}

protected handleError(operation: string, method: string) {
  return function errorHandler(res: HttpErrorResponse) {
      this.logger.error(res);
      const eMsg = res.message || '';
      const error = `${this.entityNamePlural} ${operation} Error${
          eMsg ? ': ' + eMsg : ''
          }`;
      this.notify(error, method);
  }.bind(this);
}

protected notify(message: string, method: string) {
}
}
